import { ProjectDetailsTab } from "./ProjectDetailsTabEnum";

export const ProjectDetailsTabRoute = {
  'base-information': ProjectDetailsTab.BASE_INFORMATION,
  'planning': ProjectDetailsTab.PLANNING,
  'supervision': ProjectDetailsTab.SUPERVISION,
  'agreements': ProjectDetailsTab.AGREEMENTS,
  'financial': ProjectDetailsTab.FINANCIAL,
  'risk': ProjectDetailsTab.RISK,
  'products': ProjectDetailsTab.PRODUCTS,
  'management': ProjectDetailsTab.MANAGEMENT,
  'evolution': ProjectDetailsTab.EVOLUTION,
  'acquisitions': ProjectDetailsTab.ACQUISITIONS,
}
